import DiscoverNews from './discover-news';

export default class DiscoverNewsMobile extends DiscoverNews {
    constructor(...args) {
        super(...args);

    }

    init() {
        super.init();

        this.dom.next = this.dom.component.querySelector(".next");
        this.dom.prev = this.dom.component.querySelector(".prev");
        this.dom.bullets = this.dom.component.querySelectorAll(".bullet");
        this.dom.container_articles = this.dom.component.querySelector(".container-articles");
    }

    bind() {
        super.bind();

        this.dom.prev.addEventListener("click", this._process.bind(this, "prev"));
        this.dom.next.addEventListener("click", this._process.bind(this, "next"));
    }

    _process(direction){

        if ( direction == "next" ){
            this.dom.container_articles.style.transform = "translateX(-43%)";
            this.dom.bullets[0].classList.remove("active");
            this.dom.bullets[1].classList.add("active");

        }
        if ( direction == "prev" ){
            this.dom.container_articles.style.transform = "translateX(0)";
            this.dom.bullets[1].classList.remove("active");
            this.dom.bullets[0].classList.add("active");

        }
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/discover-news/discover-news.mobile.js